/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as EmbedImages from './images.defs.js'
import * as EmbedVideo from './video.defs.js'
import * as EmbedGallery from './gallery.defs.js'
import * as EmbedExternal from './external.defs.js'
import * as EmbedRecord from './record.defs.js'

const $nsid = 'app.bsky.embed.recordWithMedia'

type $nsid = typeof $nsid

export { $nsid }

type Main = {
  $type?: 'app.bsky.embed.recordWithMedia'
  media:
    | l.$Typed<EmbedImages.Main>
    | l.$Typed<EmbedVideo.Main>
    | l.$Typed<EmbedGallery.Main>
    | l.$Typed<EmbedExternal.Main>
    | l.Unknown$TypedObject
  record: EmbedRecord.Main
}

export type { Main }

const main = /*#__PURE__*/ l.typedObject<Main>(
  $nsid,
  'main',
  /*#__PURE__*/ l.object({
    media: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<EmbedImages.Main>(
          (() => EmbedImages.main) as any,
        ),
        /*#__PURE__*/ l.typedRef<EmbedVideo.Main>(
          (() => EmbedVideo.main) as any,
        ),
        /*#__PURE__*/ l.typedRef<EmbedGallery.Main>(
          (() => EmbedGallery.main) as any,
        ),
        /*#__PURE__*/ l.typedRef<EmbedExternal.Main>(
          (() => EmbedExternal.main) as any,
        ),
      ],
      false,
    ),
    record: /*#__PURE__*/ l.ref<EmbedRecord.Main>(
      (() => EmbedRecord.main) as any,
    ),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type View = {
  $type?: 'app.bsky.embed.recordWithMedia#view'
  media:
    | l.$Typed<EmbedImages.View>
    | l.$Typed<EmbedVideo.View>
    | l.$Typed<EmbedGallery.View>
    | l.$Typed<EmbedExternal.View>
    | l.Unknown$TypedObject
  record: EmbedRecord.View
}

export type { View }

const view = /*#__PURE__*/ l.typedObject<View>(
  $nsid,
  'view',
  /*#__PURE__*/ l.object({
    media: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<EmbedImages.View>(
          (() => EmbedImages.view) as any,
        ),
        /*#__PURE__*/ l.typedRef<EmbedVideo.View>(
          (() => EmbedVideo.view) as any,
        ),
        /*#__PURE__*/ l.typedRef<EmbedGallery.View>(
          (() => EmbedGallery.view) as any,
        ),
        /*#__PURE__*/ l.typedRef<EmbedExternal.View>(
          (() => EmbedExternal.view) as any,
        ),
      ],
      false,
    ),
    record: /*#__PURE__*/ l.ref<EmbedRecord.View>(
      (() => EmbedRecord.view) as any,
    ),
  }),
)

export { view }
